module.exports = __webpack_public_path__ + "img/company_3.d25e7a97.png";